import React from "react";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { GeneratingTokens } from "@mui/icons-material";
import { formatFollowers } from "../utils/Universalfunctions";

const NewLoginCreditsModal = ({ open, onClose, userData }) => {
     return (
          <Modal
               open={open}
               onClose={onClose}
               center
               closeOnEsc
               closeOnOverlayClick
               classNames={{
                    modal: "credits-welcome-modal",
                    overlay: "credits-welcome-overlay",
                    closeButton: "credits-welcome-close",
               }}
          >
               <div className="credits-modal-box">
                    <div className="credits-badge mb-4"> welcome bonus</div>

                    <h2>Congratulations <br/> Welcome to HeyPrompt</h2>
                    <p className="credits-subtitle">
                         Your account is ready. Start generating with your available credits.
                    </p>

                    <div className="credits-card">
                         <h3>
                              <span className="credits-icon">
                                   <GeneratingTokens />
                              </span>

                              <span className="credits-value">
                                   {formatFollowers(userData?.generation_credits || 0)}
                              </span>
                         </h3>

                         <p>Generation Credits</p>
                    </div>

                    <button className="credits-btn" onClick={onClose}>
                         Continue
                    </button>
               </div>
          </Modal>
     );
};

export default NewLoginCreditsModal;